import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { auth, signInWithEmailAndPassword } from 'config/firebase';
import SignInVector from 'assets/svg/logo.svg';
import Helmet from 'components/Helmet';
import TextInput from 'components/TextInput';
import Button from 'components/Button';
import SignInWithGoogle from 'components/SignInWithGoogle';
import { useAppDispatch } from 'hooks/useStore';
import { setAlert } from 'store/error';
import './index.css';

function SignIn() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const dispatch = useAppDispatch();
    const { state } = useLocation() as {
        state?: { referrer?: string; }
    };

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        signInWithEmailAndPassword(auth, email, password)
            .catch(error => {
                dispatch(setAlert({
                    response: {
                        data: { 
                            message: error.message
                        }
                    }
                }));
            });
    }

    return (
        <div className='layout'>
            <Helmet
                title='Sign in to PrepSharp | PrepSharp Students'
            />
            <form className='signIn' onSubmit={handleSubmit}>
                <img
                    className='signIn__vector'
                    src={SignInVector}
                    alt='Sign In'
                />
                <h1 className='signIn__vectorText'>
                    Student Login
                </h1>
                {/* <h1 className='signIn__header'>
                    Sign in to your account
                </h1> */}
                <TextInput 
                    name='email'
                    label='email address'
                    onChange={(event) => setEmail(event.target.value)}
                    required
                    type='email'
                    value={email}
                />
                <TextInput
                    name='password'
                    label='password'
                    onChange={(event) => setPassword(event.target.value)}
                    required
                    type='password'
                    value={password}
                />
                <Button 
                    className='signIn__button'
                    fullWidth
                    // disabled={!email || !password}
                    type='submit'
                >
                    SIGN IN
                </Button>
                {/* <SignInWithGoogle className="signIn__googleButton" />
                <div className='signIn__action'>
                    <p className='signIn__actionText'>
                        Don't have an account?
                    </p>
                    <Link
                        to='/sign-up'
                        className='signIn__actionLink'
                        state={state?.referrer 
                            ? { referrer: state.referrer }
                            : null
                        }
                    >
                        Create one here
                    </Link>
                </div> */}
                <div className='signIn__action'>
                    <p className='signIn__actionText'>
                        Forgot password?
                    </p>
                    <Link to='/resetpassword' className='signIn__actionLink'>
                        Click here to reset
                    </Link>
                </div>
                <a className='signIn__actionLink' href={process.env.TUTOR_BASE_URL}>
                    PrepSharp Tutor Portal
                </a>
            </form>
        </div>
    );
}

export default SignIn;